import { useState } from 'react';
import {
  containsSpecialChars,
} from '@avtechsoftware/ra-javascript-utilities/src/utilities/validation/ValidationUtility';
import TransportType from '../../../../utility/types/TransportType';

const useNotificationGroupForm = (initialGroup) => {
  const [notificationGroup, setNotificationGroup] = useState(initialGroup);
  const [errorList, setErrorList] = useState([]);
  const [submittable, setSubmittable] = useState(initialGroup.recipients.length > 0);

  const validateRecipients = (recipientList) => {
    const errors = [];
    const newRecipientList = recipientList.map((recipient, index) => {
      if (recipient.userId === '' || recipient.userId === 0) {
        errors.push({ field: `contextContactType[${index}]`, message: 'Please choose a recipient.' });
        return false;
      }

      switch (parseInt(recipient.transportId, 10)) {
        case 0:
          errors.push({ field: `contextContactType[${index}]`, message: 'Please choose a notification method.' });
          return false;
        case TransportType.WEBHOOK:
          if (containsSpecialChars(recipient.context) || !/^(ftp|http|https):\/\/[^ "]+$/.test(recipient.context)) {
            errors.push({ field: `contextContactType[${index}]`, message: 'Bad url - example: http://myservice.com' });
            return false;
          }
          return true;
        case TransportType.EMAIL:
          if (!recipient.userId && (containsSpecialChars(recipient.context) || !/^[a-zA-Z0-9_!#$%&’*+/=?`{|}~^.-]+@[a-zA-Z0-9.-]+$/.test(recipient.context))) {
            errors.push({ field: `contextContactType[${index}]`, message: 'Bad email address - example: you@example.com' });
            return false;
          }
          return true;
        default:
          return true;
      }
    });
    setErrorList(errors);
    return newRecipientList;
  };

  const handleRecipientChange = (newRecipient, index) => {
    const recipientListCopy = [...notificationGroup.recipients];
    delete newRecipient.id;
    recipientListCopy[index] = newRecipient;
    setNotificationGroup({ ...notificationGroup, recipients: recipientListCopy });
  };

  const addRecipientRow = () => {
    setSubmittable(true);
    const recipientListCopy = [...notificationGroup.recipients];
    recipientListCopy.push({
      id: 0,
      transportId: '0',
      context: '',
      userId: 0,
    });
    setNotificationGroup({ ...notificationGroup, recipients: recipientListCopy });
  };

  const onDeleteBtnPress = (index) => {
    const recipientListCopy = [...notificationGroup.recipients];
    recipientListCopy.splice(index, 1);
    if (recipientListCopy.length < 1) {
      setSubmittable(false);
    }
    setNotificationGroup({ ...notificationGroup, recipients: recipientListCopy });
  };

  const onNameChange = (event) => {
    setNotificationGroup({ ...notificationGroup, name: event.target.value });
  };

  const jsonifyContext = (recipient) => {
    switch (parseInt(recipient.transportId, 10)) {
      case TransportType.EMAIL:
        return recipient.userId ? '{}' : JSON.stringify({ emailAddress: recipient.context });
      case TransportType.WEBHOOK:
        return JSON.stringify({ url: recipient.context });
      default:
        return '{}';
    }
  };

  const mapNotificationGroupForSave = () => {
    const newRecipients = notificationGroup.recipients.map((recipient) => (
      {
        ...recipient,
        userId: recipient.userId ? parseInt(recipient.userId, 10) : null,
        context: jsonifyContext(recipient),
      }
    ));
    return { ...notificationGroup, recipients: newRecipients };
  };

  const resetForm = (newGroup) => {
    setNotificationGroup(newGroup);
    setErrorList([]);
    setSubmittable(newGroup.recipients.length > 0);
  };

  return {
    notificationGroup,
    setNotificationGroup,
    errorList,
    setErrorList,
    submittable,
    setSubmittable,
    validateRecipients,
    handleRecipientChange,
    addRecipientRow,
    onDeleteBtnPress,
    onNameChange,
    mapNotificationGroupForSave,
    resetForm,
  };
};

export default useNotificationGroupForm;
